export default {
  errors: {
    outOfStock: {
      title: {
        en: 'Some products are out of stock',
      },
      text: {
        en: 'Following items are out of stock: {outOfStockItems}.',
      },
    },
    transactionError: {
      en: `
        We're sorry, but there was an issue processing your payment through Apple Pay.
        Please verify that your payment method is valid and has sufficient funds.
        If the issue persists, please try an alternative payment method or contact our support team for further assistance.
        We apologize for any inconvenience caused.
      `,
    },
  },
}
